
import cfImage from '@/utils/cfImage'

const IMG_BASE = 'https://blog.farescraper.com/wp-content/uploads/2023/11'

export default {
  methods: {
    cfImage,
    prefillSearch (payload) {
      this.$store.commit('setSearchFormPrefill', payload)
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  },
  data () {
    return {
      stepCards: [
        { key: 'one', num: '01' },
        { key: 'two', num: '02' },
        { key: 'three', num: '03' }
      ],
      whyCards: [
        { key: 'airlines', icon: '✈️' },
        { key: 'fareTypes', icon: '📊' },
        { key: 'phone', icon: '📞' },
        { key: 'online', icon: '🔒' }
      ],
      destinations: [
        { code: 'LHR', name: 'London', countryKey: 'united_kingdom', img: `${IMG_BASE}/london.jpg` },
        { code: 'JFK', name: 'New York', countryKey: 'united_states', img: `${IMG_BASE}/new-york.jpg` },
        { code: 'BCN', name: 'Barcelona', countryKey: 'spain', img: `${IMG_BASE}/barcelona.jpg` },
        { code: 'BKK', name: 'Bangkok', countryKey: 'thailand', img: `${IMG_BASE}/bangkok.jpg` },
        { code: 'DXB', name: 'Dubai', countryKey: 'uae', img: `${IMG_BASE}/dubai.jpg` },
        { code: 'CDG', name: 'Paris', countryKey: 'france', img: `${IMG_BASE}/paris.jpg` },
        { code: 'AMS', name: 'Amsterdam', countryKey: 'netherlands', img: `${IMG_BASE}/amsterdam.jpg` },
        { code: 'SIN', name: 'Singapore', countryKey: 'singapore', img: `${IMG_BASE}/singapore.jpg` },
        { code: 'NRT', name: 'Tokyo', countryKey: 'japan', img: `${IMG_BASE}/tokyo.jpg` },
        { code: 'FCO', name: 'Rome', countryKey: 'italy', img: `${IMG_BASE}/rome.jpg` },
        { code: 'IST', name: 'Istanbul', countryKey: 'turkey', img: `${IMG_BASE}/istanbul.jpg` },
        { code: 'ATH', name: 'Athens', countryKey: 'greece', img: `${IMG_BASE}/athens.jpg` }
      ],
      routes: [
        { from: 'JFK', to: 'LHR', fromName: 'New York', toName: 'London', img: `${IMG_BASE}/london.jpg` },
        { from: 'LHR', to: 'DXB', fromName: 'London', toName: 'Dubai', img: `${IMG_BASE}/dubai.jpg` },
        { from: 'LHR', to: 'BCN', fromName: 'London', toName: 'Barcelona', img: `${IMG_BASE}/barcelona.jpg` },
        { from: 'JFK', to: 'CDG', fromName: 'New York', toName: 'Paris', img: `${IMG_BASE}/paris.jpg` },
        { from: 'LHR', to: 'BKK', fromName: 'London', toName: 'Bangkok', img: `${IMG_BASE}/bangkok.jpg` },
        { from: 'CDG', to: 'BCN', fromName: 'Paris', toName: 'Barcelona', img: `${IMG_BASE}/barcelona.jpg` },
        { from: 'SYD', to: 'SIN', fromName: 'Sydney', toName: 'Singapore', img: `${IMG_BASE}/singapore.jpg` },
        { from: 'LAX', to: 'NRT', fromName: 'Los Angeles', toName: 'Tokyo', img: `${IMG_BASE}/tokyo.jpg` },
        { from: 'LHR', to: 'ATH', fromName: 'London', toName: 'Athens', img: `${IMG_BASE}/athens.jpg` }
      ]
    }
  }
}
